import React from 'react';
import { Maximize2 } from 'lucide-react';

interface ReadMoreButtonProps {
  onClick: () => void;
  className?: string;
}

const ReadMoreButton: React.FC<ReadMoreButtonProps> = ({ onClick, className = '' }) => (
  <button
    onClick={onClick}
    className={`inline-flex items-center px-4 py-2 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors ${className}`}
  >
    <Maximize2 className="w-4 h-4 mr-2" />
    Read full testimonial
  </button>
);

export default ReadMoreButton;
